import React from 'react';
import XPCalculator from './XPCalculator';
import './XPCalculatorPage.css';

const XPCalculatorPage: React.FC = () => {
  // Default scenario for the XP calculator
  const defaultScenario = {
    id: 'default',
    name: 'Default Scenario',
    description: 'Standard laning phase XP calculation'
  };

  return (
    <div className="xp-calculator-page">
      <div className="page-header">
        <h1>XP Calculator</h1>
        <p className="page-description">
          Calculate level up timings and XP requirements for League of Legends. 
          Understand when you'll reach each level based on minion farming patterns.
        </p>
      </div>
      
      <div className="page-content">
        <XPCalculator scenario={defaultScenario} />
      </div>
    </div>
  );
};

export default XPCalculatorPage;
